const inputCls = "w-full h-11 px-4 rounded-md bg-[#0B0F17] border border-[#242C3D] focus:border-indigo-500 focus:outline-none text-sm transition-colors";
const Lbl = ({ children }) => <label className="block font-mono text-[11px] uppercase tracking-widest text-slate-500 mb-2">{children}</label>;

const toLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
const toIso = (v) => (v ? new Date(v).toISOString() : "");

const Chip = ({ on, onClick, children, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`px-4 h-10 rounded-md text-sm border transition-colors ${on ? "bg-indigo-500 border-indigo-500 text-white" : "border-[#242C3D] text-slate-400 hover:text-white"}`}>{children}</button>
);

export const ThankYouEditor = ({ value: ty, onChange, onPreview, previewing }) => {
  const set = (p) => onChange({ ...ty, ...p });
  return (
    <div className="space-y-5">
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" data-testid="thank-you-enabled" checked={ty.enabled} onChange={(e) => set({ enabled: e.target.checked })} className="accent-indigo-500" />
        Show a Thank You screen after the form is submitted
      </label>
      {ty.enabled && <>
        <div>
          <Lbl>After the Thank You screen</Lbl>
          <div className="flex flex-wrap gap-2">
            <Chip on={ty.mode === "continue"} onClick={() => set({ mode: "continue" })} testid="thank-you-mode-continue">Continue to the content</Chip>
            <Chip on={ty.mode === "only"} onClick={() => set({ mode: "only" })} testid="thank-you-mode-only">Thank You only (registration, no content)</Chip>
          </div>
        </div>
        <div><Lbl>Heading</Lbl><input data-testid="thank-you-heading-input" className={inputCls} value={ty.heading} maxLength={120} onChange={(e) => set({ heading: e.target.value })} /></div>
        <div><Lbl>Message</Lbl><textarea data-testid="thank-you-message-input" rows={3} maxLength={1000} className={`${inputCls} h-auto py-3`} value={ty.message} onChange={(e) => set({ message: e.target.value })} /></div>
        {ty.mode === "continue" && (
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Lbl>Button text</Lbl><input data-testid="thank-you-button-input" className={inputCls} value={ty.button_text} maxLength={40} onChange={(e) => set({ button_text: e.target.value })} /></div>
            <div><Lbl>Auto-continue after (seconds, 0 = off)</Lbl>
              <input data-testid="thank-you-seconds-input" type="number" min={0} max={60} className={inputCls} value={ty.auto_seconds}
                onChange={(e) => set({ auto_seconds: Math.max(0, Math.min(60, parseInt(e.target.value || "0", 10))) })} /></div>
          </div>
        )}
        <div>
          <Lbl>Add to calendar (optional — leave empty to hide)</Lbl>
          <div className="grid sm:grid-cols-2 gap-4">
            <input data-testid="thank-you-cal-start" type="datetime-local" className={inputCls} value={toLocal(ty.calendar_start)} onChange={(e) => set({ calendar_start: toIso(e.target.value) })} />
            <input data-testid="thank-you-cal-end" type="datetime-local" className={inputCls} value={toLocal(ty.calendar_end)} onChange={(e) => set({ calendar_end: toIso(e.target.value) })} />
          </div>
          <input data-testid="thank-you-cal-location" className={`${inputCls} mt-3`} value={ty.calendar_location} maxLength={300} placeholder="Location or join link (defaults to this page)"
            onChange={(e) => set({ calendar_location: e.target.value })} />
          <p className="text-xs text-slate-500 mt-1.5">Times are in your local timezone. Visitors get Google Calendar and Outlook/Apple (.ics) buttons.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Lbl>Extra link text (optional)</Lbl><input data-testid="thank-you-link-text" className={inputCls} value={ty.link_text} maxLength={60} placeholder="Visit our website" onChange={(e) => set({ link_text: e.target.value })} /></div>
          <div><Lbl>Extra link URL</Lbl><input data-testid="thank-you-link-url" className={inputCls} value={ty.link_url} placeholder="https://…" onChange={(e) => set({ link_url: e.target.value })} /></div>
        </div>
        <button type="button" data-testid="thank-you-preview-toggle" onClick={onPreview}
          className="h-10 px-4 rounded-full border border-indigo-500/50 text-indigo-300 hover:bg-indigo-500/10 text-sm transition-colors">
          {previewing ? "Back to landing page preview" : "Preview Thank You screen"}
        </button>
      </>}
    </div>
  );
};
